"use client";
import { useEffect, useState } from "react";

import Mydata from "../../data/blog/whyBussiness.json";

function Content() {
  const data = Mydata[1];
  const [activeId, setActiveId] = useState("");

  return (
    <div className="space-y-6">
      {data.heading.map((item, index) => (
        <div key={index} className="space-y-4">
          {/* Heading Title */}
          <h2 id={item.id} className="blogtitle">{item.title}</h2>
          {/* <h2
           id={item.id} // Heading IDs match with anchor hrefs
           className="blogtitle"
           key={item.id}
        >
          {item.title}
        </h2> */}

          {item.content.map((contentItem, contentIndex) => (
            <p
              key={contentIndex}
              className="blogcontent" // Custom class for content paragraphs
              dangerouslySetInnerHTML={{ __html: contentItem }}
            ></p>
          ))}

          {item.subheadings.map((subheading, subIndex) => (
            <div key={subIndex} className="">
              {/* Subheading Title */}
              {subheading.title && (
                <h3 className="blogh4">{subheading.title}</h3>
              )}
              {subheading.content2 && (
                <p
                  className="blogcontent"
                  dangerouslySetInnerHTML={{ __html: subheading.content2 }}
                ></p>
              )}

              {subheading.bulletPoints && (
                <ul className="space-y-2 pl-4">
                  {subheading.bulletPoints.map((bullet, bulletIndex) => (
                    <li
                      key={bulletIndex}
                      className=" blogcontent list-disc"
                      dangerouslySetInnerHTML={{ __html: bullet }}
                    ></li>
                  ))}
                </ul>
              )}

              {subheading.content3 && (
                <p
                  className="blogcontent"
                  dangerouslySetInnerHTML={{
                    __html: subheading.content3.join(" "),
                  }}
                ></p>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

export default Content;
